<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Transplant Details EMR Preview
    </template>
    <template #body>
      <div class="sections">
        <div class="row">
          <div class="col-2" v-if="organ !== 'Heart' && organ !== 'Pancreas' && organ !== 'Intestine'">
            <ADSTextInput
              v-model="transplantType"
              disabled
              label="Transplant Type"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="transplantStartDate"
              disabled
              label="Transplant Start Date"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="transplantStartTime"
              disabled
              label="Transplant Start Time"
            />
          </div>


          <div class="col-2">
            <ADSTextInput
              v-model="transplantDate"
              disabled
              label="Transplant Date"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-3" v-if="organ === 'Kidney' && ( transplantColdDateRightKidney === null || transplantColdDateRightKidney === undefined || transplantColdDateRightKidney === '' )">
            <ADSTextInput
              v-model="transplantColdDateLeftKidney"
              disabled
              label="Removed from Cold Date - Left Kidney"
            />
          </div>

          <div class="col-3" v-if="organ === 'Liver'">
            <ADSTextInput
              v-model="removedFromColdDateLiver"
              disabled
              label="Removed from Cold Date"
            />
          </div>

          <div class="col-3" v-if="organ === 'Lung'">
            <ADSTextInput
              v-model="removedFromColdDateLungLeft"
              disabled
              label="Removed from Cold Date - Left Lung"
            />
          </div>

          <div class="col-3" v-if="organ === 'Kidney' && ( transplantColdDateRightKidney === null || transplantColdDateRightKidney === undefined || transplantColdDateRightKidney === '' )">
            <ADSTextInput
              v-model="transplantColdTimeLeftKidney"
              disabled
              label="Removed from Cold Time - Left Kidney"
            />
          </div>

          <div class="col-3" v-if="organ === 'Liver'">
            <ADSTextInput
              v-model="removedFromColdTimeLiver"
              disabled
              label="Removed from Cold Time"
            />
          </div>

          <div class="col-3" v-if="organ === 'Lung'">
            <ADSTextInput
              v-model="removedFromColdTimeLungLeft"
              disabled
              label="Removed from Cold Time - Left Lung"
            />
          </div>


          <div
            v-if="organ === 'Kidney' && ( transplantColdDateLeftKidney === null || transplantColdDateLeftKidney === undefined || transplantColdDateLeftKidney === '' )"
            class="col-3">
            <ADSTextInput
              v-model="transplantColdDateRightKidney"
              disabled
              label="Removed from Cold Date - Right Kidney"
            />
          </div>

          <div
            v-if="organ === 'Kidney' && ( transplantColdDateLeftKidney === null || transplantColdDateLeftKidney === undefined || transplantColdDateLeftKidney === '' )"
            class="col-2">
            <ADSTextInput
              v-model="transplantColdTimeRightKidney"
              disabled
              label="Removed from Cold Time - Right Kidney"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-3" v-if="organ === 'Lung'">
            <ADSTextInput
              v-model="removedFromColdDateLungRight"
              disabled
              label="Removed from Cold Date - Right Lung"
            />
          </div>
          <div class="col-3" v-if="organ === 'Lung'">
            <ADSTextInput
              v-model="removedFromColdTimeLungRight"
              disabled
              label="Removed from Cold Time - Right Lung"
            />
          </div>
        </div>  

        <div class="row">
          <div class="col-3" v-if="organ === 'Lung'">
            <ADSTextInput
              v-model="clampRemovalDateLungLeft"
              disabled
              label="Clamp Removal Date - Left Lung"
            />
          </div>
          <div class="col-3" v-if="organ === 'Lung'">
            <ADSTextInput
              v-model="clampRemovalTimeLungLeft"
              disabled
              label="Clamp Removal Time - Left Lung"
            />
          </div>
        </div> 

        <div class="row">
          <div class="col-3" v-if="organ === 'Lung'">
            <ADSTextInput
              v-model="clampRemovalDateLungRight"
              disabled
              label="Clamp Removal Date - Right Lung"
            />
          </div>
          <div class="col-3" v-if="organ === 'Lung'">
            <ADSTextInput
              v-model="clampRemovalTimeLungRight"
              disabled
              label="Clamp Removal Time - Right Lung"
            />
          </div>
        </div> 

        <div class="row">
          <div class="col-3" v-if="organ === 'Heart'">
            <ADSTextInput
              v-model="removedFromColdDateHeart"
              disabled
              label="Removed from Cold Date - Heart"
            />
          </div>
          <div class="col-3" v-if="organ === 'Heart'">
            <ADSTextInput
              v-model="removedFromColdTimeHeart"
              disabled
              label="Removed from Cold Time - Heart"
            />
          </div>
        </div> 

        <div class="row">
          <div class="col-3" v-if="organ === 'Pancreas'">
            <ADSTextInput
              v-model="removedFromColdDatePancreas"
              disabled
              label="Removed from Cold Date - Pancreas"
            />
          </div>
          <div class="col-3" v-if="organ === 'Pancreas'">
            <ADSTextInput
              v-model="removedFromColdTimePancreas"
              disabled
              label="Removed from Cold Time - Pancreas"
            />
          </div>
        </div> 

        <div class="row">
          <div class="col-3" v-if="organ === 'Heart'">
            <ADSTextInput
              v-model="clampRemovalDateHeart"
              disabled
              label="Clamp Removal Date - Heart"
            />
          </div>
          <div class="col-3" v-if="organ === 'Heart'">
            <ADSTextInput
              v-model="clampRemovalTimeHeart"
              disabled
              label="Clamp Removal Time - Heart"
            />
          </div>
        </div> 

        <div class="row">
          <div class="col-3" v-if="organ === 'Pancreas'">
            <ADSTextInput
                v-model="clampRemovalDatePancreas"
              disabled
              label="Clamp Removal Date - Pancreas"
            />
          </div>
          <div class="col-3" v-if="organ === 'Pancreas'">
            <ADSTextInput
              v-model="clampRemovalTimePancreas"
              disabled
              label="Clamp Removal Time - Pancreas"
            />
          </div>
        </div> 

        <div class="row">
          <div class="col-3" v-if="organ === 'Intestine'">
            <ADSTextInput
                v-model="portalVeinClampDateIntestine"
              disabled
              label="Portal Vein Clamp Date - Intestine"
            />
          </div>
          <div class="col-3" v-if="organ === 'Intestine'">
            <ADSTextInput
              v-model="portalVeinClampTimeIntestine"
              disabled
              label="Portal Vein Clamp Time - Intestine"
            />
          </div>
        </div> 

        <div class="row">
          <div class="col-3" v-if="organ === 'Intestine'">
            <ADSTextInput
                v-model="portalVeinCrossClampDateIntestine"
              disabled
              label="Portal Vein Cross Clamp Date - Intestine"
            />
          </div>
          <div class="col-3" v-if="organ === 'Intestine'">
            <ADSTextInput
              v-model="portalVeinCrossClampTimeIntestine"
              disabled
              label="Portal Vein Cross Clamp Time - Intestine"
            />
          </div>
        </div> 

        <div class="row">
          <div class="col-3" v-if="organ === 'Intestine'">
            <ADSTextInput
                v-model="hepaticArteryClampRemovalDateIntestine"
              disabled
              label="Hepatic Artery Clamp Removal Date - Intestine"
            />
          </div>
          <div class="col-3" v-if="organ === 'Intestine'">
            <ADSTextInput
              v-model="hepaticArteryClampRemovalTimeIntestine"
              disabled
              label="Hepatic Artery Clamp Removal Time - Intestine"
            />
          </div>
        </div> 

        <div class="row">
          <div v-if="organ === 'Kidney' && ( clampRemovalDateRightKidney === null || clampRemovalDateRightKidney === undefined || clampRemovalDateRightKidney === '' )" 
          class="col-3">
            <ADSTextInput
              v-model="clampRemovalDateLeftKidney"
              disabled
              label="Clamp Removal Date - Left Kidney"
            />
          </div>
          <div v-if="organ === 'Kidney' && ( clampRemovalDateRightKidney === null || clampRemovalDateRightKidney === undefined || clampRemovalDateRightKidney === '' )" 
          class="col-3">
            <ADSTextInput
              v-model="clampRemovalTimeLeftKidney"
              disabled
              label="Clamp Removal Time - Left Kidney"
            />
          </div>
          <div v-if="organ === 'Kidney' && ( clampRemovalDateLeftKidney === null || clampRemovalDateLeftKidney === undefined || clampRemovalDateLeftKidney === '' )" 
          class="col-3">
            <ADSTextInput
              v-model="clampRemovalDateRightKidney"
              disabled
              label="Clamp Removal Date - Right Kidney"
            />
          </div>
          <div v-if="organ === 'Kidney' && ( clampRemovalDateLeftKidney === null || clampRemovalDateLeftKidney === undefined || clampRemovalDateLeftKidney === '' )" 
          class="col-3">
            <ADSTextInput
              v-model="clampRemovalTimeRightKidney"
              disabled
              label="Clamp Removal Time - Right Kidney"
            />
          </div>
          <div v-if="organ === 'Liver'" class="col-3">
            <ADSTextInput
              v-model="portalVeinCrossClampDate"
              disabled
              label="Portal Vein Cross Clamp Date"
            />
          </div>
          <div v-if="organ === 'Liver'" class="col-3">
            <ADSTextInput
              v-model="portalVeinCrossClampTime"
              disabled
              label="Portal Vein Cross Clamp Time"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-3" v-if="organ === 'Liver'">
            <ADSTextInput
              v-model="perfusionPumpDate"
              disabled
              label="Normothermic Perfusion Pump Removal Date"
            />
          </div>
          <div class="col-3" v-if="organ === 'Liver'">
            <ADSTextInput
              v-model="perfusionPumpTime"
              disabled
              label="Normothermic Perfusion Pump Removal Time"
            />
          </div>
          <div v-if="organ === 'Liver'" class="col-3">
            <ADSTextInput
              v-model="portalVeinClampRemovalDate"
              disabled
              label="Portal Vein Clamp Removal Date"
            />
          </div>
          <div v-if="organ === 'Liver'" class="col-3">
            <ADSTextInput
              v-model="portalVeinClampRemovalTime"
              disabled
              label="Portal Vein Clamp Removal Time"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-3" v-if="organ !== 'Heart' && organ !== 'Lung'">
            <ADSTextInput
              v-model="vesselUsed"
              disabled
              label="Vessel Used"
            />
          </div>
          <div class="col-3" v-if="organ === 'Liver'">
            <ADSTextInput
              v-model="hepaticArteryClampRemovalDate"
              disabled
              label="Hepatic Artery Clamp Removal Date"
            />
          </div>
          <div class="col-3" v-if="organ === 'Liver'">
            <ADSTextInput
              v-model="hepaticArteryClampRemovalTime"
              disabled
              label="Hepatic Artery Clamp Removal Time"
            />
          </div>
        </div>
      </div>
    </template>
  </ADSCardSection>
</template>

<script>
import _ from 'lodash';

export default {
  name: "TransplantSectionDetails",
  props: {
    patient: {
      type: Object,
      default: null,
    },
    patientBundle: {
      type: Object,
      default: null,
    },
    organ: {
      type: String,
      default: null,
    }
  },
  data() {
    return {
      transplantType: this.getTransplantType( this.patientBundle ),
      transplantStartDate: this.getTransplantStartDate( this.patientBundle ),
      transplantStartTime: this.getTransplantStartTime( this.patientBundle )?.substring( 0, 5 ),
      transplantDate: this.getTransplantDate( this.patientBundle ),
      transplantColdDateLeftKidney: this.getTransplantColdDateLeftKidney( this.patientBundle ),
      transplantColdTimeLeftKidney: this.getTransplantColdTimeLeftKidney( this.patientBundle )?.substring( 0, 5 ),
      removedFromColdDateLiver: this.getRemovedFromColdDateLiver( this.patientBundle ),
      removedFromColdTimeLiver: this.getRemovedFromColdTimeLiver( this.patientBundle )?.substring( 0, 5 ),
      removedFromColdDateLungLeft: this.getRemovedFromColdDateLungLeft( this.patientBundle ),
      removedFromColdTimeLungLeft: this.getRemovedFromColdTimeLungLeft( this.patientBundle )?.substring( 0, 5 ),
      removedFromColdDateLungRight: this.getRemovedFromColdDateLungRight( this.patientBundle ),
      removedFromColdTimeLungRight: this.getRemovedFromColdTimeLungRight( this.patientBundle )?.substring( 0, 5 ),
      clampRemovalDateLungLeft: this.getClampRemovalDateLungLeft( this.patientBundle ),
      clampRemovalTimeLungLeft: this.getClampRemovalTimeLungLeft( this.patientBundle )?.substring( 0, 5 ),
      clampRemovalDateLungRight: this.getClampRemovalDateLungRight( this.patientBundle ),
      clampRemovalTimeLungRight: this.getClampRemovalTimeLungRight( this.patientBundle )?.substring( 0, 5 ),
      clampRemovalDateHeart: this.getClampRemovalDateHeart( this.patientBundle ),
      clampRemovalTimeHeart: this.getClampRemovalTimeHeart( this.patientBundle )?.substring( 0, 5 ),
      removedFromColdDateHeart: this.getRemovedFromColdDateHeart( this.patientBundle ),
      removedFromColdTimeHeart: this.getRemovedFromColdTimeHeart( this.patientBundle )?.substring( 0, 5 ),
      clampRemovalDatePancreas: this.getClampRemovalDatePancreas( this.patientBundle ),
      clampRemovalTimePancreas: this.getClampRemovalTimePancreas( this.patientBundle )?.substring( 0, 5 ),
      removedFromColdDatePancreas: this.getRemovedFromColdDatePancreas( this.patientBundle ),
      removedFromColdTimePancreas: this.getRemovedFromColdTimePancreas( this.patientBundle )?.substring( 0, 5 ),
      portalVeinCrossClampDateIntestine: this.getPortalVeinCrossClampDateIntestine( this.patientBundle ),
      portalVeinCrossClampTimeIntestine: this.getPortalVeinCrossClampTimeIntestine( this.patientBundle )?.substring( 0, 5 ),
      portalVeinClampDateIntestine: this.getPortalVeinClampDateIntestine( this.patientBundle ),
      portalVeinClampTimeIntestine: this.getPortalVeinClampTimeIntestine( this.patientBundle )?.substring( 0, 5 ),
      hepaticArteryClampRemovalDateIntestine: this.getHepaticArteryClampRemovalDateIntestine( this.patientBundle ),
      hepaticArteryClampRemovalTimeIntestine: this.getHepaticArteryClampRemovalTimeIntestine( this.patientBundle )?.substring( 0, 5 ),
      transplantColdDateRightKidney: this.getTransplantColdDateRightKidney( this.patientBundle ),
      transplantColdTimeRightKidney: this.getTransplantColdTimeRightKidney( this.patientBundle )?.substring( 0, 5 ),
      clampRemovalDateLeftKidney: this.getClampRemovalDateLeftKidney( this.patientBundle, this.organ ),
      clampRemovalTimeLeftKidney: this.getClampRemovalTimeLeftKidney( this.patientBundle, this.organ )?.substring( 0, 5 ),
      clampRemovalDateRightKidney: this.getClampRemovalDateRightKidney( this.patientBundle ),
      clampRemovalTimeRightKidney: this.getClampRemovalTimeRightKidney( this.patientBundle )?.substring( 0, 5 ),
      vesselUsed: this.getVesselUsed( this.patientBundle ),
      portalVeinCrossClampDate: this.getPortalVeinCrossClampDate( this.patientBundle ),
      portalVeinCrossClampTime: this.getPortalVeinCrossClampTime( this.patientBundle )?.substring( 0, 5 ),
      perfusionPumpDate: this.getPerfusionPumpDate( this.patientBundle ),
      perfusionPumpTime: this.getPerfusionPumpTime( this.patientBundle )?.substring( 0, 5 ),
      portalVeinClampRemovalDate: this.getPortalVeinClampRemovalDate( this.patientBundle ),
      portalVeinClampRemovalTime: this.getPortalVeinClampRemovalTime( this.patientBundle )?.substring( 0, 5 ),
      hepaticArteryClampRemovalDate: this.getHepaticArteryClampRemovalDate( this.patientBundle ),
      hepaticArteryClampRemovalTime: this.getHepaticArteryClampRemovalTime( this.patientBundle )?.substring( 0, 5 ),
    };
    },
   mounted() {
    
    },
  methods: {
    combineProps() {
      return `${this.patient}`;
    },
    getRemovedFromColdDateLabel() {
      return this.organ === 'Kidney' ? 'Removed from Cold Date - Left Kidney' : 'Removed from Cold Date';
    },
    getRemovedFromColdTimeLabel() {
      return this.organ === 'Kidney' ? 'Removed from Cold Time - Left Kidney' : 'Removed from Cold Time';
    },
    getSmartdataComponentValue( patientBundle, observationCode, valuePath = 'valueString' ) {
      const entries = patientBundle?.entries;
      if( !entries?.length ) {
        return null;
      }
      const smartdataGroups = entries.filter( ( n ) =>
        _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata'
      );
      const group = smartdataGroups[0];
      if( !group ) {
        return null;
      }
      const match = group.filter( ( n ) => _.get( n, 'resource.code.coding[0].code' ) === observationCode && 
      _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) );
      if( !match[0] ) {
        return null;
      }
      const raw = _.get( match[0], `resource.component[0].${valuePath}` );
      if( raw === null || raw === undefined ) {
        return null;
      }
      return String( raw );
    },
    getTransplantType( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8301' );
    },
    getTransplantStartDate( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8084', 'valueDateTime' );
    },
    getTransplantStartTime( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8085', 'valueTime' );
    },
    getTransplantDate( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8299', 'valueDateTime' );
    },
    getTransplantColdDateLeftKidney( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8303', 'valueDateTime' );
    },
    getRemovedFromColdDateLiver( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8321', 'valueDateTime' );
    },
    getRemovedFromColdTimeLiver( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8322', 'valueTime' );
    },
    getRemovedFromColdDateLungLeft( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8333', 'valueDateTime' );
    },
    getRemovedFromColdTimeLungLeft( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8334', 'valueTime' );
    },
    getRemovedFromColdDateLungRight( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8335', 'valueDateTime' );
    },
    getRemovedFromColdTimeLungRight( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8336', 'valueTime' );
    },
    getClampRemovalDateLungLeft( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8337', 'valueDateTime' );
    },
    getClampRemovalTimeLungLeft( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8338', 'valueTime' );
    },
    getClampRemovalDateLungRight( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8339', 'valueDateTime' );
    },
    getClampRemovalTimeLungRight( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8340', 'valueTime' );
    },
    getClampRemovalDateHeart( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8331', 'valueDateTime' );
    },
    getClampRemovalTimeHeart( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8332', 'valueTime' );
    },
    getRemovedFromColdDateHeart( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8329', 'valueDateTime' );
    },
    getRemovedFromColdTimeHeart( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8330', 'valueTime' );
    },
    getClampRemovalDatePancreas( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8331', 'valueDateTime' );
    },
    getClampRemovalTimePancreas( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8332', 'valueTime' );
    },
    getRemovedFromColdDatePancreas( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8329', 'valueDateTime' );
    },
    getRemovedFromColdTimePancreas( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8330', 'valueTime' );
    },
    getPortalVeinCrossClampDateIntestine( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8357', 'valueDateTime' );
    },
    getPortalVeinCrossClampTimeIntestine( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8358', 'valueTime' );
    },
    getPortalVeinClampDateIntestine( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8377', 'valueDateTime' );
    },
    getPortalVeinClampTimeIntestine( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8359', 'valueTime' );
    },
    getHepaticArteryClampRemovalDateIntestine( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8244', 'valueDateTime' );
    },
    getHepaticArteryClampRemovalTimeIntestine( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8245', 'valueTime' );
    },
    getTransplantColdTimeLeftKidney( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8304', 'valueTime' );
    },
    getTransplantColdDateRightKidney( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8305', 'valueDateTime' );
    },
    getTransplantColdTimeRightKidney( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8306', 'valueTime' );
    },
    getClampRemovalDateLeftKidney( patientBundle, organ ) {
      if( organ === 'Kidney' ) {
        return this.getSmartdataComponentValue( patientBundle, 'SK#8307', 'valueDateTime' );
      }
      return this.getSmartdataComponentValue( patientBundle, 'SK#8244', 'valueDateTime' );
    },
    getClampRemovalTimeLeftKidney( patientBundle, organ ) {
      if( organ === 'Kidney' ) {
        return this.getSmartdataComponentValue( patientBundle, 'SK#8308', 'valueTime' );
      }
      return this.getSmartdataComponentValue( patientBundle, 'SK#8245', 'valueTime' );
    },
    getClampRemovalDateRightKidney( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8309', 'valueDateTime' );
    },
    getClampRemovalTimeRightKidney( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8310', 'valueTime' );
    },
    getVesselUsed( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8311', 'valueBoolean' );
    },
    getPortalVeinCrossClampDate( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8319', 'valueDateTime' );
    },
    getPortalVeinCrossClampTime( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8320', 'valueTime' );
    },
    getPerfusionPumpDate( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8323', 'valueDateTime' );
    },
    getPerfusionPumpTime( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8324', 'valueTime' );
    },
    getPortalVeinClampRemovalDate( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8325', 'valueDateTime' );
    },
    getPortalVeinClampRemovalTime( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8326', 'valueTime' );
    },
    getHepaticArteryClampRemovalDate( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8327', 'valueDateTime' );
    },
    getHepaticArteryClampRemovalTime( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8328', 'valueTime' );
    },
  },
};
</script>

<style scoped>

/* .card {
  height: 560px;
} */

.sectionHeading {
  background-color: rgb(59, 53, 53);
  color: white;
  padding-left: 5px;
}

.page-content .summary-card .card-header .summary-name {
  padding-left: 35px;
  padding-top: 4px;
  font-weight: 300;
}

.sections {
  font-size: 15px;
  height: 660px;
  width: 1400px;
  /* overflow: scroll; */
  padding-left: 10px;
  padding-top: 5px;
}

.inputDisplay {
border-style: solid;
background-color: #F2F2F2;
}

.fieldName {
  font-weight: 700;
  font-size: 0.875rem;
  padding-top: 5.5px;
  padding-bottom: 2.5px;
}

:deep(.afflo-ds-form-control) {
  width: max-content;
}

:deep(label) {
  width: max-content;
}

</style>
